import { borderRadius } from '#/common/hooks/useClientTheme';
import { color } from '@nuvolo/nuux-theme/utils';
import styled from 'styled-components';

const Styles = styled.div`
  height: 100%;

  .dx-widget.dx-button {
    height: 44px;
    box-shadow: none;
  }

  .dx-list-item-content,
  .dx-list-item.dx-item {
    white-space: normal;
    padding: 0;
    margin: 0;

    img {
      object-fit: contain;
      width: 10vh;
      max-width: 100px;
      max-height: 68px;
    }
  }
  .dx-list-item.dx-state-active,
  .dx-list-item.dx-state-focused {
    overflow: hidden;
    border-radius: ${borderRadius?.m};

    .dx-list-item-content {
      border-radius: ${borderRadius?.m};
      overflow: hidden;
    }
  }
  .dx-list-item-content > div > div {
    border-radius: ${borderRadius?.m};
    overflow: hidden;
    //card
    background-color: ${color('custom', 'dataGridBackground')};

    & > div > div:nth-child(2) {
      // card content
      border-top-color: ${color('ui', 'light2')};
    }
  }

  .dx-list-item.dx-item:not(:first-child) {
    margin-top: 10px;
  }
  .list-wrapper {
    h1 {
      font-size: 16px;
    }
  }

  .unselected,
  .selected {
    background: ${color('custom', 'cardBackground')} !important;
  }

  .unselected > div {
    border: 2px solid ${color('primary', 'light3')} !important;
    div: first-child {
      border: none !important;
    }
    .dx-checkbox-icon {
      font-size: 1em !important;
      border: 2px solid ${color('primary', 'light3')} !important;
    }
  }

  .selected > div {
    border: 2px solid ${color('primary', 'middle')} !important;
    div {
      border: none !important;
    }
    .dx-checkbox-icon {
      border: 2px solid ${color('custom', 'selected')} !important;
    }
  }

  .dx-checkbox-icon {
    font-size: 1em !important;
    border: 2px solid ${color('primary', 'light3')} !important;
    width: 20px !important;
    height: 20px !important;
  }

  .deselect-all {
    .dx-checkbox-icon {
      border: 2px solid ${color('custom', 'selected')} !important;
      width: 20px !important;
      height: 20px !important;
    }
  }
`;

export default Styles;
